'use strict';
import axios from 'axios';
//axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_HOSTPYAPI;
// process.env.NODE_ENV !== "production"
//   ? process.env.VUE_APP_API_MANUSA_DEV
//   : process.env.VUE_APP_API_MANUSA_PROD;
////console.log(axios.defaults)

export default {
  namespaced: true,
  state: {
    username: '',
    nombre: '',
    email: '',
    acronimo: '',
    modoapp: '',
    departamentos: [],
    permisos: [],
    secciones: [],
    autenticado: false,

    token: '',
    tipologias: null
  },
  actions: {
    async logout({ commit }) {
      axios
        .post(
          '/efirma/accion',
          { accion: 'logout' },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.getters['user/token']}`
            }
          }
        )
        .then((res) => {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('usuario');
          commit('SET_USER', res.data);
          document.location.href = '/';
          ////console.log(this.getters)
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
    // async getUser({ commit }) {
    //   console.log("getUser", this.getters["user/token"])
    //   axios.get("efirma/getusuario", {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${this.getters["user/token"]}`
    //     }
    //   })
    //   .then(res => {
    //     commit("SET_USER", res.data)
    //     ////console.log(this.getters)
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //     commit("SET_USER", null)
    //   })
    //   .then(function () {
    //       // always executed
    //   })
    // },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    setUser({ commit }, user) {
      commit('SET_USER', user);
    },

    setTipologias({ commit }, t) {
      commit('SET_TIPOLOGIAS', t);
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      state.autenticado = true;
      console.log('state.autenticado es true');
    },
    SET_USER(state, user) {
      //console.log(user)
      if (user) {
        state.username = user.username;
        state.acronimo = user.acronimo;
        state.nombre = user.nombre;
        state.email = user.email;
        state.departamentos = user.departamentos;
        state.permisos = user.permisos;
        state.secciones = user.secciones;
        state.tipologias = user.tipologias;
        state.modoapp = user.modoapp;
      } else {
        state.token = '';
        state.username = '';
        state.acronimo = '';
        state.nombre = '';
        state.email = '';
        state.departamentos = [];
        state.permisos = [];
        state.secciones = [];
        state.tipologias = null;
        state.modoapp = '';
        state.autenticado = false;
        console.log('state.autenticado es false');
      }
    },
    SET_TIPOLOGIAS(state, t) {
      state.tipologias = t;
    }
  },
  getters: {
    username: (state) => state.username,
    nombre: (state) => state.nombre,
    email: (state) => state.email,
    acronimo: (state) => state.acronimo,
    token: (state) =>
      ////console.log("getters - token", state.token)
      state.token,
    autenticado: (state) => state.autenticado,
    tipologias: (state) => state.tipologias,
    departamentos: (state) => state.departamentos,
    permisos: (state) => state.permisos,
    secciones: (state) => state.secciones,
    modoapp: (state) => state.modoapp
  }
};
